"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VarEnvValidator = void 0;
const _ = require("lodash");
const useDefaultValue = (value) => {
    return _.isNil(value) || value == 0 || isNaN(+value);
};
class VarEnvValidator {
    constructor(maxPagingLimit, defaultPagingPage) {
        this.maxPagingLimit = maxPagingLimit || 100;
        this.defaultPagingPage = defaultPagingPage || 1;
    }
    static getEnvVar(name, defaultValue) {
        const value = process.env[name];
        if (value === undefined && defaultValue === undefined) {
            const message = `env variable "${name}" is undefined`;
            throw new Error(message);
        }
        return value !== null && value !== void 0 ? value : defaultValue;
    }
    getValidLimitAndOffset(limits, pageNumber) {
        limits = useDefaultValue(limits) ? this.maxPagingLimit : _.min([+limits, this.maxPagingLimit]);
        pageNumber = useDefaultValue(pageNumber) ? this.defaultPagingPage : +pageNumber;
        let offset = limits * (pageNumber - 1);
        if (offset < 0) {
            offset = 0;
        }
        return { limit: limits, offset: offset };
    }
}
exports.VarEnvValidator = VarEnvValidator;
//# sourceMappingURL=env-validation.js.map